
import "./form.css";

function Form({children, callback = () => null}) {

    return (<form onSubmit = {(e) => {

        e.preventDefault();

        callback();

    }}>

        {children}

    </form>);

}

export default Form;